export enum DisplayGroupTypeEnum {
    // Discover
    savedSearches = 'SAVED_SEARCHES',
    targetedLists = 'TARGETED_LISTS',

    // Amplify
    distributions = 'DISTRIBUTIONS',
    newswire = 'NEWSWIRE',
    newswirePlus = 'NEWSWIRE_PLUS',
    newsroom = 'NEWSROOM',

    // Monitor
    topics = 'TOPICS',
    savedCoverage = 'SAVED_COVERAGE',
    briefings = 'BRIEFINGS',
    alerts = 'ALERTS',
    subscriptions = 'SUBSCRIPTIONS',

    // Report
    reports = 'REPORTS',

    // Visibility Intelligence Monitor
    viMonitor = 'VI_MONITOR',

    // FE Only
    favorites = 'FAVORITES',
    uncategorized = 'UNCATEGORIZED'
}
